// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zjiXfJpa0yn80lfFraKE {
  list-style-type: none;
  width: 25vw;
  min-width: 12rem;
  border-radius: 10px;
  box-shadow: 5px 5px 4px black;
}

.zjiXfJpa0yn80lfFraKE:hover {
  box-shadow: 10px 10px 10px gold;
}`, "",{"version":3,"sources":["webpack://./src/components/GenreListItem/GenreListItem.module.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,6BAAA;AACJ;;AACA;EACI,+BAAA;AAEJ","sourcesContent":[".GenreListItem {\n    list-style-type: none;\n    width: 25vw;\n    min-width: 12rem;\n    border-radius: 10px;\n    box-shadow: 5px 5px 4px black;\n}\n.GenreListItem:hover {\n    box-shadow: 10px 10px 10px  gold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"GenreListItem": `zjiXfJpa0yn80lfFraKE`
};
export default ___CSS_LOADER_EXPORT___;
